

// Lazy-loaded components for code splitting
const DocumentHistoryList = () => import(/* webpackChunkName: "document-history" */ "./pages/ListPage.vue");
const DocumentHistoryDetail = () => import(/* webpackChunkName: "document-history" */ "./pages/FormPage.vue");
const DocumentHistoryIndex = () => import(/* webpackChunkName: "document-history" */ "./pages/IndexPage.vue");
export default [
  {
    path: "/document_history",
    component: DocumentHistoryIndex,
    redirect: "/document_history/list",
    name: "document_history",
    children: [
      {
        path: "list",
        component: DocumentHistoryList,
        name: "document_history.list",
      },
      {
        path: "create",
        component: DocumentHistoryDetail,
        name: "document_history.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: DocumentHistoryDetail,
        name: "document_history.edit",
        props: { create: false },
      },
    ],
  },
];
